// extracted by mini-css-extract-plugin
export default {"element":"resource-bar_element__Owndx","inner":"resource-bar_inner__iP5Ls","link":"resource-bar_link__ejhji"};